export const environment = {
    production: true,
    // apiUrl: 'https://homolog.prehox.com/backend',
    apiUrl: 'https://backend-homolog.prehox.com',
    apiUrlSocket: 'https://monitor-homolog.prehox.com',
    libreTranslateApiUrl: 'https://translate.prehox.com',
    defaultLanguage: 'pt-br',
};
